<div class="header-fixed menubar-pin parent-container">
    <div id="base">
        <div class="super-container">
            <section>
                
                <div>
                    <!-- <div *ngIf="isPageLoad == true" class="page-loader-container">
                        <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                    </div> -->

                        <div class="calendar-top-btns" *ngIf="isPageLoad == false">
                            <button type="button" class="add-calendar-btn" (click)="openCreateChooser()">
                                <i class="ph ph-plus"></i>
                                {{ 'createEventTopBtnText' | translate }}
                            </button>
                            <button type="button" class="add-calendar-btn" *ngIf="!isCalendarPublish && showPublishButton" [disabled]="isCalendarPublish"
                                (click)="openPublishConfirmBox()">
                                {{ 'publishText' | translate }}
                            </button>
                        </div>

                        <div class="calendar-bottom-container">
                            <div *ngIf="isPageLoad" class="ngfc-root calendar-skeleton-container">
                                <div class="ngfc-sidebar-slot">
                                    <div class="calendar-skeleton-sidebar">
                                        <p-skeleton width="100%" height="14rem" borderRadius="16px" />
                                        <p-skeleton width="100%" height="2.25rem" borderRadius="8px" />
                                        <div class="calendar-skeleton-categories">
                                            <p-skeleton *ngFor="let cell of generateDummyArray(4)" width="100%" height="1.25rem" />
                                        </div>
                                    </div>
                                </div>
                                <div class="calendar-skeleton-main">
                                    <div class="calendar-skeleton-toolbar">
                                        <p-skeleton width="7rem" height="2rem" borderRadius="8px" />
                                        <p-skeleton width="10rem" height="1.5rem" />
                                        <div class="calendar-skeleton-view-buttons">
                                            <p-skeleton *ngFor="let cell of generateDummyArray(4)" width="4rem" height="2rem" borderRadius="8px" />
                                        </div>
                                    </div>
                                    <div class="calendar-skeleton-weekdays">
                                        <p-skeleton *ngFor="let cell of generateDummyArray(7)" width="60%" height="0.9rem" />
                                    </div>
                                    <div class="calendar-skeleton-grid">
                                        <p-skeleton *ngFor="let cell of generateDummyArray(42)" width="100%" height="100%" borderRadius="8px" />
                                    </div>
                                </div>
                            </div>
                            <ngfc-calendar *ngIf="!isPageLoad" [fontSize]="16" [events]="events" [categories]="ngfcCategoriesList"
                                [locale]="ngfcLocale" [editable]="false" [(date)]="ngfcDate"
                                [view]="ngfcView" (viewChange)="onNgfcViewChange($event)"
                                (eventClick)="handleEventClick($event)" (dayClick)="handleDayClick($event)"
                                (slotClick)="handleDayClick($event)">
                            </ngfc-calendar>
                            <!-- <full-calendar  #calendar [options]="calendarOptions"></full-calendar> -->
                        </div>
                </div>
            </section>
        </div>
    </div>
</div>

<p-dialog [(visible)]="eventPopupVisible" [modal]="true" [focusOnShow]="false"
    [style]="{width: '640px'}" [draggable]="false" [resizable]="false" [closable]="!academicCalendarFormSubmit"
    (onHide)="closeForm()" styleClass="event-info-dialog" [showHeader]="false">
    <div class="event-info-header">
        <div class="event-info-header-text">
            <h2 class="event-info-title">{{'eventInfoHeading' | translate}}</h2>
        </div>
        <div class="edit-holiday-header-actions">
            <button type="button" class="event-info-close-btn event-info-close-btn-danger" *ngIf="editEventVisible"
                (click)="deleteEventForm()" aria-label="Delete" title="{{'deleteText' | translate}}"
                [disabled]="academicCalendarFormSubmit">
                <i class="ri-delete-bin-line"></i>
            </button>
            <button type="button" class="event-info-close-btn" (click)="closeForm()" aria-label="Close"
                [disabled]="academicCalendarFormSubmit">
                <i class="ri-close-line"></i>
            </button>
        </div>
    </div>
    <form [formGroup]="academicCalendarForm" (ngSubmit)="onFormSubmit()">
        <div class="popup-body modal-body">
            <div class="form-group">
                <label for="academicEventName">
                    {{'academicEventName'|translate}}
                    <span class="required-param">
                        {{'requiredParam'|translate}}
                    </span>
                </label>
                <input pInputText type="text" id="academicEventName" formControlName="academicEventName"
                    class="w-100" maxlength="200" placeholder="{{'academicEventNamePlaceholder' | translate}}">
                <div class="field-char-count">
                    {{ (academicCalendarForm.get('academicEventName')?.value?.length) || 0 }} / 200
                </div>
                <div class="error-block">
                    <div *ngIf="academicCalendarForm.get('academicEventName')?.touched">
                        <small
                            *ngIf="academicCalendarForm.get('academicEventName')?.hasError('required') || academicCalendarForm.get('academicEventName')?.hasError('minlength')">
                            {{'requiredacademicEventName'|translate}}
                        </small>
                        <small *ngIf="!academicCalendarForm.get('academicEventName')?.hasError('required') && !academicCalendarForm.get('academicEventName')?.hasError('minlength')
                            && academicCalendarForm.get('academicEventName')?.hasError('maxlength')
                            ">
                            {{'maxAcademicEventName' | translate}}
                        </small>
                        <small *ngIf="
                               !academicCalendarForm.get('academicEventName')?.hasError('required')
                            && !academicCalendarForm.get('academicEventName')?.hasError('minlength')
                            && !academicCalendarForm.get('academicEventName')?.hasError('maxlength')
                            && academicCalendarForm.get('academicEventName')?.hasError('invalidCharacter')">
                            {{'invalidTitle'| translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>
                    {{'selectEventCategory' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-dropdown #eventCategoryDropdown [options]="eventCategoryListData" optionLabel="displayName" optionValue="id"
                    optionDisabled="disabled" formControlName="selectedEventCategory" [filter]="true"
                    filterBy="displayName" [style]="{width: '100%'}"
                    placeholder="{{'pleaseSelectEventCategory' | translate}}">
                    <ng-template pTemplate="header">
                        <button type="button" class="add-category-dropdown-btn"
                            (click)="openAddCategoryInput(); eventCategoryDropdown.hide()">
                            <i class="ri-add-large-line"></i>
                            <span>{{'addCategoryBtnText' | translate}}</span>
                        </button>
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-category>
                        <div class="category-option-row category-selected-row">
                            <span class="category-color-dot" *ngIf="getCategoryColor(category)"
                                [ngStyle]="{ 'background-color': getCategoryColor(category) }"></span>
                            <span class="category-option-name">{{ category.displayName }}</span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-category>
                        <div class="category-option-row">
                            <span class="category-option-name-with-dot">
                                <span class="category-color-dot" *ngIf="getCategoryColor(category)"
                                    [ngStyle]="{ 'background-color': getCategoryColor(category) }"></span>
                                <span class="category-option-name">{{ category.displayName }}</span>
                            </span>
                            <span class="category-option-actions" *ngIf="category.id !== 4">
                                <i class="ri-edit-line" title="{{'editFeatureText' | translate}}"
                                    (click)="openEditCategoryInput(category, $event); eventCategoryDropdown.hide()"></i>
                                <i class="ri-delete-bin-line" title="{{'deleteText' | translate}}"
                                    (click)="openDeleteCategoryConfirm(category, $event); eventCategoryDropdown.hide()"></i>
                            </span>
                        </div>
                    </ng-template>
                </p-dropdown>
                <div class="add-category-inline" *ngIf="showAddCategoryInput">
                    <label class="add-category-inline-label">
                        <i class="ri-price-tag-3-line"></i>
                        {{'eventCategoryName' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input pInputText type="text" [(ngModel)]="newCategoryName" [ngModelOptions]="{standalone: true}"
                        placeholder="{{'eventCategoryPlaceholder' | translate}}" maxlength="30" class="w-100">
                    <div class="field-char-count">
                        {{ newCategoryName?.length || 0 }} / 30
                    </div>
                    <label class="add-category-inline-label">
                        <i class="ri-palette-line"></i>
                        {{'colorCode' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <div class="color-selector">
                        <div *ngFor="let color of categoryColorList" class="color-swatch"
                            [ngStyle]="{ 'background-color': color.colorCode }"
                            [class.selected]="newCategoryColorId === color.pkColorId"
                            [class.disabled]="creatingCategory"
                            (click)="!creatingCategory && selectNewCategoryColor(color.pkColorId)">
                            <i class="ri-check-line" *ngIf="newCategoryColorId === color.pkColorId"></i>
                        </div>
                    </div>
                    <div class="add-category-inline-actions">
                        <button type="button" class="event-info-btn event-info-btn-secondary"
                            (click)="cancelAddCategoryInput()" [disabled]="creatingCategory">
                            {{'closeText' | translate}}
                        </button>
                        <button type="button" class="event-info-btn event-info-btn-primary"
                            (click)="createEventCategoryInline()"
                            [disabled]="creatingCategory || !newCategoryName?.trim() || !newCategoryColorId">
                            {{ editingCategoryId ? ('updateEventCategoryBtnText' | translate) : ('createEventCategoryBtnText' | translate) }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="holidayDescription">
                    {{'eventDescriptionText' | translate}}
                </label>
                <textarea pInputTextarea name="holidayDescription" id="holidayDescription"
                    formControlName="academicEventDescription" class="description-field" rows="3"
                    placeholder="{{'eventDescriptionPlaceholder' | translate}}">
                </textarea>
                <div class="error-block">
                    <div *ngIf="academicCalendarForm.get('academicEventDescription').errors &&
                                (academicCalendarForm.get('academicEventDescription').dirty ||
                                 academicCalendarForm.get('academicEventDescription').touched)">
                        <small class="text-danger"
                            *ngIf="academicCalendarForm.get('academicEventDescription').errors?.['minlength']">
                            {{'minDescriptionLimit' | translate}}
                        </small>
                        <small class="text-danger"
                            *ngIf="academicCalendarForm.get('academicEventDescription').errors?.['maxlength']">
                            {{'maxDescriptionLimit' | translate}}
                        </small>
                        <small class="text-danger" *ngIf="
                            !academicCalendarForm.get('academicEventDescription').errors?.['maxlength'] &&
                            !academicCalendarForm.get('academicEventDescription').errors?.['minlength'] &&
                            academicCalendarForm.get('academicEventDescription').errors?.['invalidCharacter']">
                            {{'invalidDescription' | translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>
                    {{'eventType' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-dropdown [options]="[
                        {label: ('SelectEvent' | translate), value: ''},
                        {label: ('fullAcademic' | translate), value: 'fullAcademicYear'},
                        {label: ('repeat' | translate), value: 'repeat'},
                        {label: ('custom' | translate), value: 'custom'}
                    ]" optionLabel="label" optionValue="value" formControlName="selectedEventType"
                    (onChange)="handleEventTypeChange($event.value)" [style]="{width: '100%'}"
                    placeholder="{{'eventType' | translate}}">
                </p-dropdown>
            </div>

            <div *ngIf="selectedEventType ==='fullAcademicYear'" class="dates-container">
                <div class="form-group">
                    <label for="startDate">
                        {{'startDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="startDate" formControlName="startDate" [min]="academicStartDate"
                        [max]="academicEndDate" (change)="validateDates()">
                    <div class="error-block" *ngIf="academicCalendarForm.get('startDate')?.touched">
                        <small *ngIf="academicCalendarForm.controls['startDate'].hasError('invalidStartDate')">
                            {{'startDateValidationMessage' | translate}} {{ academicStartDate }}
                        </small>
                        <small *ngIf="
                            !academicCalendarForm.controls['startDate'].hasError('invalidStartDate') &&
                            academicCalendarForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                            {{'dateValidation' | translate}}
                        </small>
                    </div>
                    <div class="error-block" *ngIf="academicCalendarForm.get('startDate')?.untouched">
                        <small *ngIf="
                            !academicCalendarForm.controls['startDate'].hasError('invalidStartDate') &&
                            academicCalendarForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                            {{'dateValidation' | translate}}
                        </small>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedEventType === 'repeat'" class="dates-container">
                <div class="form-group">
                    <label for="startDate">
                        {{ 'startDate' | translate }}
                        <span class="required-param">{{ 'requiredParam' | translate }}</span>
                    </label>
                    <input type="date" id="startDate" formControlName="startDate"
                        [min]="academicStartDate" [max]="academicEndDate" (change)="validateDates()">

                    <div class="error-block" *ngIf="academicCalendarForm.get('startDate')?.touched">
                        <small *ngIf="academicCalendarForm.controls['startDate'].hasError('invalidStartDate')">
                            {{ 'startDateValidationMessage' | translate }} {{ academicStartDate }}
                        </small>
                        <small *ngIf="academicCalendarForm.controls['startDate'].hasError('startDateMoreThanEndDate')">
                            {{ 'dateValidation' | translate }}
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="endDate">
                        {{ 'endDate' | translate }}
                        <span class="required-param">{{ 'requiredParam' | translate }}</span>
                    </label>
                    <input type="date" id="endDate" formControlName="endDate"
                        [min]="academicStartDate" [max]="academicEndDate" (change)="validateDates()">

                    <div class="error-block">
                        <small *ngIf="academicCalendarForm.get('endDate')?.hasError('invalidEndDate')">
                            {{ 'endDateValidationMessage' | translate }} {{ academicEndDate }}
                        </small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="startTime">
                        {{ 'startTime' | translate }}
                        <span class="required-param">{{ 'requiredParam' | translate }}</span>
                    </label>
                    <input type="time" id="startTime" formControlName="startTime" (change)="validateDates()">

                    <div class="error-block">
                        <small *ngIf="academicCalendarForm.get('startTime')?.hasError('invalidStartTime')">
                            {{ 'startTimeValidationMessage' | translate }}
                        </small>
                    </div>
                </div>

                <div class="form-group">
                    <label for="endTime">
                        {{ "endTime" | translate }}
                        <span class="required-param">{{ 'requiredParam' | translate }}</span>
                    </label>
                    <input type="time" id="endTime" formControlName="endTime" (change)="validateDates()">

                    <div class="error-block">
                        <small *ngIf="academicCalendarForm.get('endTime')?.hasError('invalidEndTime')">
                            {{ 'endTimeValidationMessage' | translate }}
                        </small>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedEventType ==='custom'" class="dates-container">
                <div class="form-group">
                    <label for="startDate">
                        {{'startDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="startDate" formControlName="startDate" [min]="academicStartDate"
                        [max]="academicEndDate" (change)="validateDates()">
                    <div class="error-block" *ngIf="academicCalendarForm.get('startDate')?.touched">
                        <small *ngIf="academicCalendarForm.controls['startDate'].hasError('invalidStartDate')">
                            {{'startDateValidationMessage' | translate}} {{ academicStartDate }}
                        </small>
                        <small *ngIf="
                            !academicCalendarForm.controls['startDate'].hasError('invalidStartDate') &&
                            academicCalendarForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                            {{'dateValidation' | translate}}
                        </small>
                    </div>
                    <div class="error-block" *ngIf="academicCalendarForm.get('startDate')?.untouched">
                        <small *ngIf="
                            !academicCalendarForm.controls['startDate'].hasError('invalidStartDate') &&
                            academicCalendarForm.controls['startDate'].hasError('startDateMorethenEndDate')">
                            {{'dateValidation' | translate}}
                        </small>
                    </div>
                </div>

                <div class="form-group">
                    <label for="endDate">
                        {{'endDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="endDate" formControlName="endDate" [min]="academicStartDate"
                       [max]="academicEndDate" (change)="validateDates()">
                    <div class="error-block">
                        <div>
                            <small *ngIf="academicCalendarForm.get('endDate')?.hasError('invalidEndDate')">
                                {{'endDateValidationMessage' | translate}} {{ academicEndDate }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="startTime">
                        {{ 'startTime' | translate }}
                    </label>
                    <input type="time" id="startTime" formControlName="startTime" (change)="validateDates()">
                    <div class="error-block">
                        <div>
                            <small *ngIf="academicCalendarForm.get('startTime')?.hasError('required')">
                                {{'startTimeValidationMessage' | translate}}
                            </small>
                            <small *ngIf="
                                !academicCalendarForm.get('startTime')?.hasError('required') &&
                                academicCalendarForm.get('startTime')?.hasError('startTimeMorethenEndTime')">
                                {{'endTimeValidationMessage' | translate}}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="endTime">
                        {{ 'endTime' | translate }}
                    </label>
                    <input type="time" id="endTime" formControlName="endTime" (change)="validateDates()">
                    <div class="error-block">
                        <div>
                            <small *ngIf="academicCalendarForm.get('endTime')?.hasError('required')">
                                {{'endTimeValidationMessage' | translate}}
                            </small>
                            <small *ngIf="academicCalendarForm.get('endTime')?.hasError('invalidEndTime')">
                                {{'endTimeValidationMessage' | translate}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>
                    {{'selectClasses' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-multiSelect [options]="groupedClassDropdownData" optionLabel="displayName" [group]="true"
                    optionValue="pkClassStandardsId" optionGroupLabel="classCategoryName" optionGroupChildren="items"
                    formControlName="selectedClasses" (onChange)="selectClasses($event.value)"
                    [filter]="true" filterBy="displayName" [style]="{width: '100%'}" display="comma"
                    [maxSelectedLabels]="5" [selectedItemsLabel]="'classesSelectedLabel' | translate"
                    appendTo="body"
                    placeholder="{{'pleaseSelectClassesPlaceholder' | translate}}">
                    <ng-template pTemplate="group" let-group>
                        <div class="class-group-header" (click)="toggleEventClassGroup(group, $event)">
                            <span class="class-group-checkbox"
                                [class.checked]="isClassGroupFullySelected(group, academicCalendarForm.get('selectedClasses')?.value)">
                                <i class="ri-check-line"></i>
                            </span>
                            {{ group.classCategoryName }}
                        </div>
                    </ng-template>
                </p-multiSelect>
            </div>

            <div class="form-group" *ngIf="!editButtonVisible">
                <label>
                    {{'selectStaff' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-multiSelect [options]="staffListData" optionLabel="displayName" optionValue="staffId"
                    formControlName="selectedStaffs" (onChange)="selectStaffs($event.value)"
                    (onClear)="clearStaffData()" [filter]="true" filterBy="displayName" [style]="{width: '100%'}"
                    display="comma" [maxSelectedLabels]="5" [selectedItemsLabel]="'staffSelectedLabel' | translate"
                    placeholder="{{'pleaseSelectStaffPlaceholder' | translate}}">
                </p-multiSelect>
            </div>
        </div>
        <div class="modal-footer modal-footer-buttons">
            <button type="button" class="event-info-btn event-info-btn-secondary"
                (click)="closeForm()" aria-label="Close"
                [disabled]="academicCalendarFormSubmit">{{'closeText' | translate}}</button>
            <button type="submit" class="event-info-btn event-info-btn-primary"
                [disabled]="academicCalendarForm.invalid || academicCalendarFormSubmit || academicCalendarForm.pristine">
                <div *ngIf="academicCalendarFormSubmit;else createOrUpdateSubmitText">
                    <app-button-loader></app-button-loader>
                </div>
                <ng-template #createOrUpdateSubmitText>
                    {{
                    editEventVisible ? ('updateEventBtnText' | translate) : ('createEventBtnText' | translate)
                    }}
                </ng-template>
            </button>
        </div>
    </form>
</p-dialog>

<p-dialog [(visible)]="deleteEventVisible" [modal]="true"
    [style]="{width: '460px'}" [draggable]="false" [resizable]="false" [closable]="!academicCalendarFormSubmit"
    (onHide)="closeForm()" styleClass="delete-category-dialog" [showHeader]="false">
    <div class="delete-category-header">
        <div class="delete-category-header-text">
            <span class="delete-category-icon-badge">
                <i class="ri-alert-line"></i>
            </span>
            <h2 class="delete-category-title">{{'deleteEventHeadingModal' | translate}}</h2>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeForm()" aria-label="Close"
            [disabled]="academicCalendarFormSubmit">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="popup-body delete-pop-up modal-body text-left">
        <p class="delete-category-message">
            {{ selectedEventType !== 'repeat' ?
            ('deleteParagraph' | translate) : ('recurringEvent' | translate) }}
        </p>
        <div class="delete-category-warning-banner">
            <i class="ri-error-warning-line"></i>
            {{'actionCannotBeUndone' | translate}}
        </div>
    </div>
    <div class="modal-footer modal-footer-buttons">
        <button type="button" class="event-info-btn event-info-btn-secondary" (click)="closeForm()"
            [disabled]="academicCalendarFormSubmit" aria-label="Close">
            {{'closeText' | translate}}
        </button>
        <button type="button" class="event-info-btn event-info-btn-danger" (click)="deleteEvents()"
            [disabled]="academicCalendarFormSubmit">
            <div *ngIf="academicCalendarFormSubmit;else deleteEventSubmitText">
                <app-button-loader></app-button-loader>
            </div>
            <ng-template #deleteEventSubmitText>
                {{ 'deleteText' | translate }}
            </ng-template>
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="calendarPublishConfirmBox" [modal]="true"
    [style]="{width: '460px'}" [draggable]="false" [resizable]="false" [closable]="!academicCalendarFormSubmit"
    (onHide)="closeForm()" styleClass="publish-calendar-dialog" [showHeader]="false">
    <div class="publish-calendar-header">
        <div class="publish-calendar-header-text">
            <span class="publish-calendar-icon-badge">
                <i class="ri-rocket-2-line"></i>
            </span>
            <h2 class="publish-calendar-title">{{'confirmationPublishText' | translate}}</h2>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeForm()" aria-label="Close"
            [disabled]="academicCalendarFormSubmit">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="popup-body publish-calendar-body modal-body text-left">
        <p class="publish-calendar-message">
            {{'confirmPublishMessage' | translate}}
        </p>
        <div class="publish-calendar-chip">
            <i class="ri-calendar-line"></i>
            {{'academicCalendarLabel' | translate}} {{academicYearLabel}}
        </div>
        <div class="publish-calendar-warning-banner">
            <i class="ri-error-warning-line"></i>
            {{'publishWarningNote' | translate}}
        </div>
    </div>
    <div class="modal-footer modal-footer-buttons">
        <button type="button" class="event-info-btn event-info-btn-secondary" (click)="closeForm()"
            [disabled]="academicCalendarFormSubmit" aria-label="Close">
            {{'closeText' | translate}}
        </button>
        <button type="button" class="event-info-btn publish-calendar-btn-primary" (click)="publishCalendar()"
            [disabled]="academicCalendarFormSubmit">
            <div *ngIf="academicCalendarFormSubmit;else publishCalendarSubmitText">
                <app-button-loader></app-button-loader>
            </div>
            <ng-template #publishCalendarSubmitText>
                <i class="ri-rocket-2-line"></i>
                {{ 'publishCalendarBtnText' | translate }}
            </ng-template>
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="deleteCategoryConfirmVisible" [modal]="true"
    [style]="{width: '460px'}" [draggable]="false" [resizable]="false" [closable]="!deletingCategorySubmit"
    (onHide)="closeDeleteCategoryConfirm()" styleClass="delete-category-dialog" [showHeader]="false">
    <div class="delete-category-header">
        <div class="delete-category-header-text">
            <span class="delete-category-icon-badge" [class.delete-category-icon-badge-amber]="categoryDeleteConfirmRequired">
                <i class="ri-alert-line"></i>
            </span>
            <h2 class="delete-category-title">
                {{ categoryDeleteConfirmRequired ? ('warningHeadingText' | translate) : ('deleteHeadingModal' | translate) }}
            </h2>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeDeleteCategoryConfirm()" aria-label="Close"
            [disabled]="deletingCategorySubmit">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="popup-body delete-pop-up modal-body text-left">
        <p class="delete-category-message" *ngIf="!categoryDeleteConfirmRequired">
            {{'deleteCategoryConfirmMessage' | translate}}
        </p>
        <div class="delete-category-conflict-banner" *ngIf="categoryDeleteConfirmRequired">
            <i class="ri-error-warning-line"></i>
            <div>
                <p class="delete-category-message">
                    {{categoryDeleteConflictData.length}} {{ categoryDeleteConflictData.length === 1 ? ('eventSingular' | translate) : ('eventPlural' | translate) }} {{'whenEventScheduleInDeleteCategory' | translate}}
                </p>
                <p class="delete-category-message">{{'giveDeleteEventCondition' | translate}}</p>
            </div>
        </div>
        <div class="delete-category-chip" *ngIf="deletingCategory">
            <span class="delete-category-chip-dot" [ngStyle]="{ 'background-color': deletingCategoryColor }"></span>
            {{ deletingCategory.displayName }}
        </div>
        <div class="delete-category-warning-banner" *ngIf="!categoryDeleteConfirmRequired">
            <i class="ri-error-warning-line"></i>
            {{'actionCannotBeUndone' | translate}}
        </div>
    </div>
    <div class="modal-footer modal-footer-buttons">
        <button type="button" class="event-info-btn event-info-btn-secondary" (click)="closeDeleteCategoryConfirm()"
            [disabled]="deletingCategorySubmit" aria-label="Close">
            {{'closeText' | translate}}
        </button>
        <button type="button" class="event-info-btn event-info-btn-danger"
            (click)="categoryDeleteConfirmRequired ? confirmDeleteEventCategoryInline() : deleteEventCategoryInline()"
            [disabled]="deletingCategorySubmit">
            <div *ngIf="deletingCategorySubmit;else deleteSubmitText">
                <app-button-loader></app-button-loader>
            </div>
            <ng-template #deleteSubmitText>
                <i class="ri-delete-bin-line"></i>
                {{ 'deleteCategoryBtnText' | translate }}
            </ng-template>
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="editHolidayPopupVisible" [modal]="true" [focusOnShow]="false"
    [style]="{width: '640px'}" [draggable]="false" [resizable]="false" [closable]="!editHolidayFormSubmit"
    (onHide)="closeEditHolidayForm()" styleClass="edit-holiday-dialog" [showHeader]="false">
    <div class="edit-holiday-header">
        <div class="edit-holiday-header-text">
            <h2 class="edit-holiday-title">{{'editHolidayPopupHeadingText' | translate}}</h2>
        </div>
        <div class="edit-holiday-header-actions">
            <button type="button" class="event-info-close-btn event-info-close-btn-danger"
                (click)="openDeleteHolidayConfirm()" aria-label="Delete" title="{{'deleteText' | translate}}"
                [disabled]="editHolidayFormSubmit">
                <i class="ri-delete-bin-line"></i>
            </button>
            <button type="button" class="event-info-close-btn" (click)="closeEditHolidayForm()" aria-label="Close"
                [disabled]="editHolidayFormSubmit">
                <i class="ri-close-line"></i>
            </button>
        </div>
    </div>
    <form [formGroup]="editHolidayForm" (ngSubmit)="editHolidayFormSubmitFn()">
        <div class="popup-body modal-body">
            <div class="form-group">
                <label for="holidayName">
                    <i class="ri-sun-line"></i>
                    {{'academicHolidayName' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <input pInputText type="text" id="holidayName" formControlName="holidayName"
                    class="w-100" maxlength="60" placeholder="{{'academicHolidayNamePlaceholder' | translate}}">
                <div class="field-char-count">
                    {{ (editHolidayForm.get('holidayName')?.value?.length) || 0 }} / 60
                </div>
                <div class="error-block">
                    <div *ngIf="editHolidayForm.get('holidayName')?.touched">
                        <small *ngIf="editHolidayForm.get('holidayName')?.hasError('required') || editHolidayForm.get('holidayName')?.hasError('minlength')">
                            {{'requiredacademicEventName' | translate}}
                        </small>
                        <small *ngIf="editHolidayForm.get('holidayName')?.hasError('maxlength')">
                            {{'maxAcademicEventName' | translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="holidayDescriptionField">
                    <i class="ri-align-left"></i>
                    {{'holdiayDescription' | translate}}
                </label>
                <textarea pInputTextarea id="holidayDescriptionField" formControlName="holidayDescription"
                    class="description-field" rows="3" placeholder="{{'holidayDescriptionPlaceholder' | translate}}">
                </textarea>
                <div class="error-block">
                    <div *ngIf="editHolidayForm.get('holidayDescription')?.errors && (editHolidayForm.get('holidayDescription')?.dirty || editHolidayForm.get('holidayDescription')?.touched)">
                        <small class="text-danger" *ngIf="editHolidayForm.get('holidayDescription')?.errors?.['minlength']">
                            {{'minDescriptionLimit' | translate}}
                        </small>
                        <small class="text-danger" *ngIf="editHolidayForm.get('holidayDescription')?.errors?.['maxlength']">
                            {{'maxDescriptionLimit' | translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="dates-container">
                <div class="form-group">
                    <label for="holidayStartDate">
                        <i class="ri-calendar-line"></i>
                        {{'startDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="holidayStartDate" formControlName="holidayStartDate"
                        [min]="academicStartDate" [max]="academicEndDate">
                </div>
                <div class="form-group">
                    <label for="holidayEndDate">
                        <i class="ri-calendar-line"></i>
                        {{'endDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="holidayEndDate" formControlName="holidayEndDate"
                        [min]="academicStartDate" [max]="academicEndDate">
                </div>
            </div>

            <div class="edit-holiday-duration-chip" *ngIf="editHolidayDurationDays > 0">
                <i class="ri-time-line"></i>
                {{ editHolidayDurationDays }} {{ editHolidayDurationDays === 1 ? ('day' | translate) : ('days' | translate) }}
            </div>

            <div class="form-group">
                <label>
                    <i class="ri-graduation-cap-line"></i>
                    {{'selectClasses' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-multiSelect [options]="groupedClassDropdownData" optionLabel="displayName" [group]="true"
                    optionValue="pkClassStandardsId" optionGroupLabel="classCategoryName" optionGroupChildren="items"
                    formControlName="holidaySelectedClasses" (onChange)="selectHolidayClasses($event.value)"
                    [filter]="true" filterBy="displayName" [style]="{width: '100%'}" display="comma"
                    [maxSelectedLabels]="5" [selectedItemsLabel]="'classesSelectedLabel' | translate"
                    placeholder="{{'pleaseSelectClassesPlaceholder' | translate}}">
                    <ng-template pTemplate="group" let-group>
                        <div class="class-group-header" (click)="toggleEditHolidayClassGroup(group, $event)">
                            <span class="class-group-checkbox"
                                [class.checked]="isClassGroupFullySelected(group, editHolidayForm.get('holidaySelectedClasses')?.value)">
                                <i class="ri-check-line"></i>
                            </span>
                            {{ group.classCategoryName }}
                        </div>
                    </ng-template>
                </p-multiSelect>
                <div class="edit-holiday-info-note">
                    <i class="ri-information-line"></i>
                    {{'holidayClassesInfoNote' | translate}}
                </div>
            </div>
        </div>
        <div class="modal-footer modal-footer-buttons">
            <button type="button" class="event-info-btn event-info-btn-secondary"
                (click)="closeEditHolidayForm()" aria-label="Close"
                [disabled]="editHolidayFormSubmit">{{'closeText' | translate}}</button>
            <button type="submit" class="event-info-btn event-info-btn-holiday"
                [disabled]="editHolidayForm.invalid || editHolidayFormSubmit || editHolidayForm.pristine">
                <div *ngIf="editHolidayFormSubmit;else holidaySubmitText">
                    <app-button-loader></app-button-loader>
                </div>
                <ng-template #holidaySubmitText>
                    {{ 'updateHolidayBtnText' | translate }}
                </ng-template>
            </button>
        </div>
    </form>
</p-dialog>

<p-dialog [(visible)]="deleteHolidayConfirmVisible" [modal]="true"
    [style]="{width: '420px'}" [draggable]="false" [resizable]="false" [closable]="!deletingHolidaySubmit"
    (onHide)="closeDeleteHolidayConfirm()" styleClass="delete-category-dialog" [showHeader]="false">
    <div class="delete-category-header">
        <div class="delete-category-header-text">
            <span class="delete-category-icon-badge">
                <i class="ri-alert-line"></i>
            </span>
            <h2 class="delete-category-title">{{'deleteHolidayHeadingModal' | translate}}</h2>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeDeleteHolidayConfirm()" aria-label="Close"
            [disabled]="deletingHolidaySubmit">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="popup-body delete-pop-up modal-body text-left">
        <p class="delete-category-message">
            {{'deleteHolidayParagraph' | translate}}
        </p>
        <div class="delete-category-warning-banner">
            <i class="ri-error-warning-line"></i>
            {{'actionCannotBeUndone' | translate}}
        </div>
    </div>
    <div class="modal-footer modal-footer-buttons">
        <button type="button" class="event-info-btn event-info-btn-secondary" (click)="closeDeleteHolidayConfirm()"
            [disabled]="deletingHolidaySubmit" aria-label="Close">
            {{'closeText' | translate}}
        </button>
        <button type="button" class="event-info-btn event-info-btn-danger"
            (click)="deleteHolidayFn()" [disabled]="deletingHolidaySubmit">
            <div *ngIf="deletingHolidaySubmit;else deleteHolidaySubmitText">
                <app-button-loader></app-button-loader>
            </div>
            <ng-template #deleteHolidaySubmitText>
                <i class="ri-delete-bin-line"></i>
                {{ 'deleteHolidayBtnText' | translate }}
            </ng-template>
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="createChooserPopupVisible" [modal]="true"
    [style]="{width: '640px'}" [draggable]="false" [resizable]="false"
    (onHide)="closeCreateChooser()" styleClass="create-chooser-dialog" [showHeader]="false">
    <div class="edit-holiday-header">
        <div class="edit-holiday-header-text">
            <h2 class="edit-holiday-title">{{'createChooserHeading' | translate}}</h2>
            <p class="create-chooser-subheading">{{'createChooserSubheading' | translate}}</p>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeCreateChooser()" aria-label="Close">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="popup-body modal-body">
        <div class="create-chooser-options">
            <div class="create-chooser-option" [class.selected]="createChooserSelection === 'event'"
                (click)="selectCreateChooserOption('event')">
                <div class="create-chooser-option-top">
                    <span class="create-chooser-icon create-chooser-icon-event">
                        <i class="ri-calendar-2-line"></i>
                    </span>
                    <span class="create-chooser-radio" [class.checked]="createChooserSelection === 'event'"></span>
                </div>
                <div class="create-chooser-option-label">{{'createChooserEventLabel' | translate}}</div>
                <div class="create-chooser-option-description">{{'createChooserEventDescription' | translate}}</div>
            </div>
            <div class="create-chooser-option" [class.selected]="createChooserSelection === 'holiday'"
                (click)="selectCreateChooserOption('holiday')">
                <div class="create-chooser-option-top">
                    <span class="create-chooser-icon create-chooser-icon-holiday">
                        <i class="ri-sun-line"></i>
                    </span>
                    <span class="create-chooser-radio" [class.checked]="createChooserSelection === 'holiday'"></span>
                </div>
                <div class="create-chooser-option-label">{{'createChooserHolidayLabel' | translate}}</div>
                <div class="create-chooser-option-description">{{'createChooserHolidayDescription' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="modal-footer modal-footer-buttons">
        <button type="button" class="event-info-btn event-info-btn-secondary" (click)="closeCreateChooser()">
            {{'cancelBtnText' | translate}}
        </button>
        <button type="button" class="event-info-btn event-info-btn-primary"
            (click)="continueCreateChooser()" [disabled]="!createChooserSelection">
            {{'continueBtnText' | translate}}
            <i class="ri-arrow-right-line"></i>
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="createHolidayPopupVisible" [modal]="true"
    [style]="{width: '640px'}" [draggable]="false" [resizable]="false" [closable]="!createHolidayFormSubmit"
    (onHide)="closeCreateHolidayForm()" styleClass="edit-holiday-dialog" [showHeader]="false">
    <div class="edit-holiday-header">
        <div class="edit-holiday-header-text">
            <h2 class="edit-holiday-title">{{'popupAddHolidayHeadingText' | translate}}</h2>
        </div>
        <button type="button" class="event-info-close-btn" (click)="closeCreateHolidayForm()" aria-label="Close"
            [disabled]="createHolidayFormSubmit">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <form [formGroup]="createHolidayForm" (ngSubmit)="createHolidayFormSubmitFn()">
        <div class="popup-body modal-body">
            <div class="form-group">
                <label for="createHolidayName">
                    <i class="ri-sun-line"></i>
                    {{'academicHolidayName' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <input pInputText type="text" id="createHolidayName" formControlName="holidayName"
                    class="w-100" maxlength="60" placeholder="{{'academicHolidayNamePlaceholder' | translate}}">
                <div class="field-char-count">
                    {{ (createHolidayForm.get('holidayName')?.value?.length) || 0 }} / 60
                </div>
                <div class="error-block">
                    <div *ngIf="createHolidayForm.get('holidayName')?.touched">
                        <small *ngIf="createHolidayForm.get('holidayName')?.hasError('required') || createHolidayForm.get('holidayName')?.hasError('minlength')">
                            {{'requiredacademicEventName' | translate}}
                        </small>
                        <small *ngIf="createHolidayForm.get('holidayName')?.hasError('maxlength')">
                            {{'maxAcademicEventName' | translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="createHolidayDescriptionField">
                    <i class="ri-align-left"></i>
                    {{'holdiayDescription' | translate}}
                </label>
                <textarea pInputTextarea id="createHolidayDescriptionField" formControlName="holidayDescription"
                    class="description-field" rows="3" placeholder="{{'holidayDescriptionPlaceholder' | translate}}">
                </textarea>
                <div class="error-block">
                    <div *ngIf="createHolidayForm.get('holidayDescription')?.errors && (createHolidayForm.get('holidayDescription')?.dirty || createHolidayForm.get('holidayDescription')?.touched)">
                        <small class="text-danger" *ngIf="createHolidayForm.get('holidayDescription')?.errors?.['minlength']">
                            {{'minDescriptionLimit' | translate}}
                        </small>
                        <small class="text-danger" *ngIf="createHolidayForm.get('holidayDescription')?.errors?.['maxlength']">
                            {{'maxDescriptionLimit' | translate}}
                        </small>
                    </div>
                </div>
            </div>

            <div class="dates-container">
                <div class="form-group">
                    <label for="createHolidayStartDate">
                        <i class="ri-calendar-line"></i>
                        {{'startDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="createHolidayStartDate" formControlName="holidayStartDate"
                        [min]="academicStartDate" [max]="academicEndDate">
                </div>
                <div class="form-group">
                    <label for="createHolidayEndDate">
                        <i class="ri-calendar-line"></i>
                        {{'endDate' | translate}}
                        <span class="required-param">
                            {{'requiredParam' | translate}}
                        </span>
                    </label>
                    <input type="date" id="createHolidayEndDate" formControlName="holidayEndDate"
                        [min]="academicStartDate" [max]="academicEndDate">
                </div>
            </div>

            <div class="edit-holiday-duration-chip" *ngIf="createHolidayDurationDays > 0">
                <i class="ri-time-line"></i>
                {{ createHolidayDurationDays }} {{ createHolidayDurationDays === 1 ? ('day' | translate) : ('days' | translate) }}
            </div>

            <div class="form-group">
                <label>
                    <i class="ri-graduation-cap-line"></i>
                    {{'selectClasses' | translate}}
                    <span class="required-param">
                        {{'requiredParam' | translate}}
                    </span>
                </label>
                <p-multiSelect [options]="groupedClassDropdownData" optionLabel="displayName" [group]="true"
                    optionValue="pkClassStandardsId" optionGroupLabel="classCategoryName" optionGroupChildren="items"
                    formControlName="holidaySelectedClasses" (onChange)="selectCreateHolidayClasses($event.value)"
                    [filter]="true" filterBy="displayName" [style]="{width: '100%'}" display="comma"
                    [maxSelectedLabels]="5" [selectedItemsLabel]="'classesSelectedLabel' | translate"
                    placeholder="{{'pleaseSelectClassesPlaceholder' | translate}}">
                    <ng-template pTemplate="group" let-group>
                        <div class="class-group-header" (click)="toggleCreateHolidayClassGroup(group, $event)">
                            <span class="class-group-checkbox"
                                [class.checked]="isClassGroupFullySelected(group, createHolidayForm.get('holidaySelectedClasses')?.value)">
                                <i class="ri-check-line"></i>
                            </span>
                            {{ group.classCategoryName }}
                        </div>
                    </ng-template>
                </p-multiSelect>
                <div class="edit-holiday-info-note">
                    <i class="ri-information-line"></i>
                    {{'holidayClassesInfoNote' | translate}}
                </div>
            </div>
        </div>
        <div class="modal-footer modal-footer-buttons">
            <button type="button" class="event-info-btn event-info-btn-secondary"
                (click)="closeCreateHolidayForm()" aria-label="Close"
                [disabled]="createHolidayFormSubmit">{{'closeText' | translate}}</button>
            <button type="submit" class="event-info-btn event-info-btn-holiday"
                [disabled]="createHolidayForm.invalid || createHolidayFormSubmit">
                <div *ngIf="createHolidayFormSubmit;else createHolidaySubmitText">
                    <app-button-loader></app-button-loader>
                </div>
                <ng-template #createHolidaySubmitText>
                    {{ 'createHolidayBtnText' | translate }}
                </ng-template>
            </button>
        </div>
    </form>
</p-dialog>